import { render, staticRenderFns } from "./consumeHis.vue?vue&type=template&id=219a42c0&scoped=true"
import script from "./consumeHis.vue?vue&type=script&lang=js"
export * from "./consumeHis.vue?vue&type=script&lang=js"
import style0 from "./consumeHis.vue?vue&type=style&index=0&id=219a42c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a42c0",
  null
  
)

export default component.exports